"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AdminSettingsHomeGenericSuccessResponse () {
        return AdminSettingsHomeGenericSuccessResponse;
    },
    get BrandingResponse () {
        return BrandingResponse;
    },
    get FunctionsResponse () {
        return FunctionsResponse;
    },
    get SeatUsageResponse () {
        return SeatUsageResponse;
    },
    get SettingsResponse () {
        return SettingsResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const SeatUsageResponse = _zod.z.object({
    active: _zod.z.number().int().nonnegative(),
    max: _zod.z.number().int().nonnegative(),
    remaining: _zod.z.number().int().nonnegative(),
    companyName: _zod.z.string()
});
const BrandingResponse = _zod.z.object({
    navColor: _zod.z.string().optional(),
    iconColor: _zod.z.string().optional(),
    preferredNavigation: _zod.z.enum(_models.COMPANY_PREFERRED_NAVIGATION_VALUES),
    tenantFlags: _zod.z.object({
        customBrandingEnabled: _zod.z.boolean(),
        canBypassCustomBrandingFlag: _zod.z.boolean(),
        sideNavigationEnabled: _zod.z.boolean()
    })
});
const FunctionsResponse = _zod.z.object({
    functions: _zod.z.array(_zod.z.object({
        key: _zod.z.enum(_models.COMPANY_FUNCTION_KEYS),
        label: _zod.z.string(),
        value: _zod.z.enum(_models.COMPANY_FUNCTION_VALUES),
        disabled: _zod.z.boolean().optional(),
        helpText: _zod.z.string().optional(),
        options: _zod.z.array(_zod.z.object({
            value: _zod.z.enum(_models.COMPANY_FUNCTION_VALUES),
            label: _zod.z.string()
        }))
    }))
});
const SettingsResponse = _zod.z.object({
    settings: _zod.z.array(_zod.z.object({
        key: _zod.z.enum(_models.COMPANY_HOME_BOOLEAN_SETTING_KEYS),
        label: _zod.z.string(),
        value: _zod.z.boolean(),
        tooltip: _zod.z.string().optional(),
        options: _zod.z.array(_zod.z.object({
            value: _zod.z.boolean(),
            label: _zod.z.string()
        }))
    })),
    /**
	 * Non-boolean company-scoped select controls (timezone, review times, decimal places). Own-company only and
	 * server-gated: review-only controls are present only when the company has reviews enabled. Empty cross-tenant.
	 */ scalarControls: _zod.z.array(_zod.z.object({
        key: _zod.z.enum([
            "defaultTimezone",
            "defaultReviewStartTime",
            "defaultReviewCycleDueTime",
            "decimalPlaces"
        ]),
        label: _zod.z.string(),
        value: _zod.z.union([
            _zod.z.string(),
            _zod.z.number()
        ]),
        tooltip: _zod.z.string().optional(),
        options: _zod.z.array(_zod.z.object({
            value: _zod.z.union([
                _zod.z.string(),
                _zod.z.number()
            ]),
            label: _zod.z.string()
        }))
    })),
    /** Microsoft Teams setup navigation, when Teams integration is enabled; null otherwise. */ microsoftTeamsSetup: _zod.z.object({
        label: _zod.z.string(),
        buttonLabel: _zod.z.string()
    }).nullable()
});
const AdminSettingsHomeGenericSuccessResponse = _zod.z.object({
    success: _zod.z.literal(true)
});
